import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-checkpoint-chain',
  templateUrl: './checkpoint-chain.component.html',
  styleUrls: ['./checkpoint-chain.component.scss'],
})
export class CheckpointChainComponent {
  @Input() length: number = 0;
  @Input() active: number = 0;
  @Input() mydata:any;
}
